import { apiClient } from '../apiClient';

/** ISSUE-244 */
export async function bootstrapCompanyArtifacts(companyId: string): Promise<unknown> {
  const res = await apiClient.post('/onboarding/bootstrap-company', { company_id: companyId });
  return res.data;
}

/** ISSUE-246 */
export async function postFoundationPurchased(body: {
  company_id: string;
  company_name?: string;
  scheduled_at: string;
  idempotency_key?: string;
}): Promise<unknown> {
  const res = await apiClient.post('/onboarding/foundation-purchased', body);
  return res.data;
}
